import { useSelector } from '@shared/store';

export function useCurrentUserId(): number | undefined {
  return useSelector(state => state.appState.currentUserId);
}
